export default __webpack_public_path__ + "static/Averta-Extrabold-219ab54a555ee89d47af6044a3acc364.woff";